export class ValidationError extends Error {
  constructor(private errors: { field: string; error: string }[]) {
    super('Bad Request');
    this.name = 'Bad Request';
  }

  override toString() {
    return this.errors.map(error => error.error).join(', ');
  }

  fieldError(field: string) {
    return this.errors.find(error => error.field === field)?.error;
  }

  hasError(field: string) {
    return !!this.fieldError(field);
  }

  get fieldErrors() {
    return this.errors;
  }
}

export class UnauthorizedException extends Error {
  constructor(private code: string) {
    super('Unauthorized');
    this.name = 'Unauthorized';
  }

  getCode() {
    return this.code;
  }
}

export class UnableToRefreshToken extends Error {
  constructor() {
    super('Unable to refresh token');
    this.name = UnableToRefreshToken.name;
  }
}

// Nest's BadRequestFilter sends a plain exception message as `errors`, so a ValidationError can wrap a string.
export function requestErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof ValidationError) {
    const errors: unknown = error.fieldErrors;

    return (typeof errors === 'string' ? errors : error.toString()) || fallback;
  }

  const message = (error as { response?: { data?: { message?: unknown } } })?.response?.data?.message;

  return typeof message === 'string' ? message : fallback;
}
